module.exports = __webpack_public_path__ + "img/fuel (10).643af1c5.svg";